<div class="h-full min-h-0 overflow-y-auto">
  <div class="flex flex-col gap-3 pb-4 sm:gap-4 sm:pb-6">
    <!-- HEADER (ahora scrollea) -->
    <div
      class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-0"
    >
      <h2 class="text-xl sm:text-2xl font-bold text-slate-900">Resumen general</h2>

      <button
        (click)="modal_agregar_gestion_tiempo.set(true)"
        class="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded-lg font-semibold"
      >
        + Nueva Sesión
      </button>
    </div>

    <!-- STATS -->
    <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3">
      <div
        class="bg-linear-to-br from-blue-50 to-blue-100 rounded-lg p-2 sm:p-4 border border-blue-200"
      >
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-0">
          <div>
            <p class="text-xs sm:text-sm text-blue-700 font-medium">Sesiones Activas</p>
            <p class="text-lg sm:text-2xl font-bold text-blue-900 mt-0.5 sm:mt-1">
              {{ resumenDiario().sesiones_activas }}
            </p>
          </div>
          <i class="bi bi-people-fill text-2xl sm:text-3xl text-blue-600"></i>
        </div>
      </div>

      <div
        class="bg-linear-to-br from-green-50 to-green-100 rounded-lg p-2 sm:p-4 border border-green-200"
      >
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-0">
          <div>
            <p class="text-xs sm:text-sm text-green-700 font-medium">Tiempo Total Restante</p>
            <p class="text-lg sm:text-2xl font-bold text-green-900 mt-0.5 sm:mt-1">
              {{ resumenDiario().tiempo_total_restante }}
            </p>
          </div>
          <i class="bi bi-hourglass-split text-2xl sm:text-3xl text-green-600"></i>
        </div>
      </div>

      <div
        class="bg-linear-to-br from-orange-50 to-orange-100 rounded-lg p-2 sm:p-4 border border-orange-200"
      >
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-0">
          <div>
            <p class="text-xs sm:text-sm text-orange-700 font-medium">Por Terminar</p>
            <p class="text-lg sm:text-2xl font-bold text-orange-900 mt-0.5 sm:mt-1">
              {{ resumenDiario().por_terminar }}
            </p>
          </div>
          <i class="bi bi-exclamation-triangle-fill text-2xl sm:text-3xl text-orange-600"></i>
        </div>
      </div>

      <div
        class="bg-linear-to-br from-purple-50 to-purple-100 rounded-lg p-2 sm:p-4 border border-purple-200"
      >
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 sm:gap-0">
          <div>
            <p class="text-xs sm:text-sm text-purple-700 font-medium">Terminadas</p>
            <p class="text-lg sm:text-2xl font-bold text-purple-900 mt-0.5 sm:mt-1">
              {{ resumenDiario().terminadas }}
            </p>
          </div>
          <i class="bi bi-check-circle-fill text-2xl sm:text-3xl text-purple-600"></i>
        </div>
      </div>
    </div>

    <!-- Grid de sesiones activas -->
    <div
      class="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 p-1"
    >
      @for (gestion_tiempo of gestionTiemposOrdenado(); track gestion_tiempo.id; let i = $index) {
        <app-card-gestion-tiempo [gestion_tiempo]="gestion_tiempo" [index]="i" />
      }
    </div>
  </div>

  <app-dialog
    header="Agregar Gestión de Tiempo"
    [(visible)]="modal_agregar_gestion_tiempo"
    [closable]="true"
    (onHide)="modal_agregar_gestion_tiempo.set(false)"
    size="xl"
    styleClass="w-11/12 md:w-2/3 lg:w-1/2"
  >
    @if (modal_agregar_gestion_tiempo() == true) {
      <app-agregar-gestion-tiempo (cerrar)="modal_agregar_gestion_tiempo.set(false)" />
    }
  </app-dialog>
</div>
